import { type Key, memo, useState } from 'react';

import type { GroupType, TargetGroupFormValues } from './TargetGroups.types.ts';

import TargetGroups from './TargetGroups';
import { getTargetGroupData } from './TargetGroups.helpers.ts';
import { useService } from './TargetGroups.hooks.ts';

export const TargetGroupsContainer = () => {
  const [selectedTargetGroupKeys, setSelectedTargetGroupKeys] = useState<React.Key[]>([]);
  const [openTargetGroupDrawer, setOpenTargetGroupDrawer] = useState<boolean>(false);
  const [targetGroupId, setTargetGroupId] = useState<string | null>(null);
  const { createMutation, updateMutation, deleteMutation, groups, isLoading } = useService({
    targetGroupId,
  });

  const handleOpenTargetGroupDrawer = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    id: string | null,
  ) => {
    if (event) event.preventDefault();
    if (id === undefined) return;

    setTargetGroupId(id);
    setOpenTargetGroupDrawer(true);
  };

  const handleCloseTargetGroupDrawer = () => {
    setTargetGroupId(null);
    setOpenTargetGroupDrawer(false);
  };

  const handleSubmitTargetGroup = (values: TargetGroupFormValues, group: GroupType[]) => {
    const data = getTargetGroupData(values, group);
    if (values?.id) {
      updateMutation.mutate({ data: { ...data, id: values.id } });
      handleCloseTargetGroupDrawer();
      return;
    }
    createMutation.mutate(data);
    handleCloseTargetGroupDrawer();
  };

  const handleDeleteTargetGroups = () => {
    const params = { ids: selectedTargetGroupKeys.map((key: Key) => Number(key)) };
    deleteMutation.mutate(params);
    setTargetGroupId(null);
  };

  return (
    <TargetGroups
      groups={groups}
      isLoading={isLoading}
      openTargetGroupDrawer={openTargetGroupDrawer}
      onOpenTargetGroupDrawer={handleOpenTargetGroupDrawer}
      onCloseTargetGroupDrawer={handleCloseTargetGroupDrawer}
      onSubmitTargetGroup={handleSubmitTargetGroup}
      selectedTargetGroupKeys={selectedTargetGroupKeys}
      setSelectedTargetGroupKeys={setSelectedTargetGroupKeys}
      onDeleteTargetGroups={handleDeleteTargetGroups}
      targetGroupId={targetGroupId}
      itemsToDeleteCount={selectedTargetGroupKeys.length}
    />
  );
};

export default memo(TargetGroupsContainer);
